import { Injectable } from '@angular/core';
import { WritableSignal, signal } from '@angular/core';
import {TableRow, TableColumn} from '../../../shared/models/components/tables/table.models';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {  ModelPredictionsInputs,ModelInputResponse } from '../../models/serviceModels/request/modelPredictionsInputs.model';
import {  ModelPredictionsResults,ModelResultResponse } from '../../models/serviceModels/response/modelPredictionsResults.model';
import { ProjectFilterModel,InputsAndValuesModel } from '../../../shared/models/store/filter.model';
import { SavePredictionsModel } from '../../models/serviceModels/request/savePredictionsReq.model';
import { SavePredictionsResponse } from '../../models/serviceModels/response/savePredictionsResponse.model';
@Injectable({
  providedIn: 'root'
})
export class ModelPredictionsService {

  inputsColumns: WritableSignal<TableColumn[]> = signal([]);
  inputsRows: WritableSignal<TableRow[]> = signal([]);

  inputsColumnsBackUp: WritableSignal<TableColumn[]> = signal([]);
  inputsRowsBackUp: WritableSignal<TableRow[]> = signal([]);

  resultsColumns: WritableSignal<TableColumn[]> = signal([]);
  resultsRows: WritableSignal<TableRow[]> = signal([]);
  currentSelectedDate: string= "";
  currentProject: number =0;
  currentScope: number =1;
  currentCatergories: WritableSignal<string[]> = signal([]);

  constructor(private apiService: ApiService) { }

  GetInputsAndValuesFromService(filterRequest: ProjectFilterModel): Observable<ModelInputResponse> {
    return this.apiService.post('api/Data/GetInputsAndValues', filterRequest );
 }

  runModel(modelPredictionInputs: ModelPredictionsInputs[]): Observable<ModelResultResponse>{
    return this.apiService.post('api/Data/ExecuteAML', modelPredictionInputs );
  }

  save(list: SavePredictionsModel[]): Observable<SavePredictionsResponse> {
     return this.apiService.post('api/Data/savePredictions', list);
   }

  updateCaseInputs(projectId: number, changes: {caseId: number; inputId: number; value: string; runDate: string;}[]): Observable<{updated: number}> {
    const payload = changes.map(c => ({ ...c, projectId }));
    return this.apiService.put('api/Data/updateCaseInputs', payload) as Observable<{updated: number}>;
  }

  getChevronBaseline(projectId: number, runDateIso: string): Observable<any> {
    const payload = { projectId, runDate: runDateIso };
    return this.apiService.post('api/Data/chevronBaseline', payload);
  }

  getChevronAuditTrail(projectId: number, runDateIso: string): Observable<any> {
    const payload = { projectId, runDate: runDateIso };
    return this.apiService.post('api/Data/chevronAuditTrail', payload);
  }

  setInputsColumns(columns: TableColumn[]) {
    this.inputsColumns.set(columns);
  }

  setInputsRows(rows: TableRow[]) {
    this.inputsRows.set(rows);
  }

  getInputColumns() {
    return this.inputsColumns;
  }

  getInputRows() {
    return this.inputsRows;
  }

  setResultsColumns(columns: TableColumn[]) {
    this.resultsColumns.set(columns);
  }

  setResultsRows(rows: TableRow[]) {
    this.resultsRows.set(rows);
  }

  getResultsColumns() {
    return this.resultsColumns;
  }

  getResultsRows() {
    return this.resultsRows;
  }

  setCurrentCategories(categories: string[]) {
    this.currentCatergories.set(categories);
  }

  getCurrentCategories() {
    return this.currentCatergories;
  }

  setCurrentSelectedDate(currentDate: string){
    this.currentSelectedDate= currentDate;
  }

  getCurrentSelectedDate(){
    return this.currentSelectedDate;
  }

  setInputsColumnsBackup(columns: TableColumn[]) {
    this.inputsColumnsBackUp.set(columns);
  }

  setInputsRowsBackup(rows: TableRow[]) {
    this.inputsRowsBackUp.set(rows);
  }

  getInputColumnsBackup() {
    return this.inputsColumnsBackUp;
  }

  getInputRowsBackup() {
    return this.inputsRowsBackUp;
  }

  getCurrentProject(){
    return this.currentProject;
  }

  setCurrentProject(currentProject: number){
    this.currentProject= currentProject;
  }

  getCurrentScope(){
    return this.currentScope;
  }

  setCurrentScope(currentScope: number){
    this.currentScope= currentScope;
  }
}
